import React from "react";
import { Col, Row } from "react-bootstrap";
import chrome from "../../Assets/TechIcons/Google Chrome.svg";
import vsCode from "../../Assets/TechIcons/vscode.svg";
import intelliJ from "../../Assets/TechIcons/intellij-idea.svg";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={vsCode} alt="vsCode" className="tech-icon-images" />
        <div className="tech-icons-text">VS Code</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={intelliJ} alt="IntelliJ" className="tech-icon-images" />
        <div className="tech-icons-text">IntelliJ IDEA</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={chrome} alt="Chrome" className="tech-icon-images" />
        <div className="tech-icons-text">Google Chrome</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={chrome} alt="Jupyter" className="tech-icon-images" />
        <div className="tech-icons-text">Jupyter Notebook</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={chrome} alt="Colab" className="tech-icon-images" />
        <div className="tech-icons-text">Google Colab</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={chrome} alt="Power BI" className="tech-icon-images" />
        <div className="tech-icons-text">Power BI</div>
      </Col>
    </Row>
  );
}

export default Toolstack;
